export default __webpack_public_path__ + "static/media/modal-avatar.8613f669.png";